export const formatBRL = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
};

export const formatDateLong = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return iso; }
};

export const tierLabel = {
  bronze: "Bronze",
  silver: "Silver",
  gold: "Gold",
  king: "King",
};

export const statusLabel = {
  em_dia: "Em dia",
  proximo: "Próximo do vencimento",
  vencido: "Vencido",
  inativo: "Inativo",
  bloqueado: "Bloqueado",
  ativo: "Ativo",
};

export const recurrenceLabel = {
  mensal: "Mensal",
  trimestral: "Trimestral",
  semestral: "Semestral",
  anual: "Anual",
};
